import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRightIcon, BriefcaseIcon, SparklesIcon } from 'lucide-react';
export const ExploreYourPath = () => {
  const navigate = useNavigate();
  return <section id="explore-your-path" className="py-20 bg-purple-50 relative overflow-hidden" data-id="element-455">
      <div className="absolute top-0 right-0 w-80 h-80 bg-purple-100 rounded-full opacity-30 -mr-40 -mt-40" data-id="element-456"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-purple-100 rounded-full opacity-20 -ml-48 -mb-48" data-id="element-457"></div>
      <div className="container mx-auto px-4 md:px-6 relative z-10" data-id="element-458">
        <div className="text-center mb-12 max-w-3xl mx-auto" data-id="element-459">
          <h2 className="text-3xl md:text-5xl font-bold mb-4 text-black leading-tight" data-id="element-460">
            Explore your path
          </h2>
          <p className="text-lg md:text-xl text-text-secondary" data-id="element-461">
            Dive deeper into the service that matches your needs.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 max-w-5xl mx-auto" data-id="element-462">
          <button onClick={() => navigate('/fractional-head-of-ai')} className="group text-left bg-white rounded-3xl p-8 md:p-10 shadow-xl shadow-purple-900/5 hover:shadow-2xl hover:shadow-purple-900/10 transition-all duration-300 border-2 border-primary/40 hover:border-primary flex flex-col h-full relative overflow-hidden" data-id="element-463">
            <div className="absolute top-0 right-0 w-32 h-32 bg-purple-100 rounded-bl-full opacity-60 transition-transform group-hover:scale-110" data-id="element-464"></div>
            <div className="relative z-10 flex-grow" data-id="element-465">
              <div className="w-14 h-14 bg-primary text-white rounded-2xl flex items-center justify-center mb-6" data-id="element-466">
                <SparklesIcon size={28} data-id="element-467" />
              </div>
              <h3 className="text-2xl md:text-3xl font-bold text-black mb-4" data-id="element-468">
                Fractional Head of AI
              </h3>
              <p className="text-text-secondary mb-8 text-lg" data-id="element-469">
                Senior AI leadership to build agents, ship AI features, and turn
                opportunity into production outcomes.
              </p>
            </div>
            <div className="relative z-10 inline-flex items-center text-primary font-semibold text-lg" data-id="element-470">
              Explore AI services
              <ArrowRightIcon className="ml-2 h-5 w-5 transition-transform group-hover:translate-x-1" data-id="element-471" />
            </div>
          </button>
          <button onClick={() => navigate('/fractional-pm')} className="group text-left bg-white rounded-3xl p-8 md:p-10 shadow-xl shadow-purple-900/5 hover:shadow-2xl hover:shadow-purple-900/10 transition-all duration-300 border border-purple-100 hover:border-primary/30 flex flex-col h-full relative overflow-hidden" data-id="element-472">
            <div className="absolute top-0 right-0 w-32 h-32 bg-purple-50 rounded-bl-full opacity-50 transition-transform group-hover:scale-110" data-id="element-473"></div>
            <div className="relative z-10 flex-grow" data-id="element-474">
              <div className="w-14 h-14 bg-purple-100 text-primary rounded-2xl flex items-center justify-center mb-6" data-id="element-475">
                <BriefcaseIcon size={28} data-id="element-476" />
              </div>
              <h3 className="text-2xl md:text-3xl font-bold text-black mb-4" data-id="element-477">
                Fractional Product Management
              </h3>
              <p className="text-text-secondary mb-8 text-lg" data-id="element-478">
                AI-fluent product leadership to define vision, streamline
                execution, and drive growth.
              </p>
            </div>
            <div className="relative z-10 inline-flex items-center text-primary font-semibold text-lg" data-id="element-479">
              Explore PM services
              <ArrowRightIcon className="ml-2 h-5 w-5 transition-transform group-hover:translate-x-1" data-id="element-480" />
            </div>
          </button>
        </div>
      </div>
    </section>;
};